// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "86c6558e8e9f276d1e5d20b75e40ee3dd38cd8ed/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};